(() => {
 const init = (root = document) => root.querySelectorAll('[data-minbie-tabs]').forEach(section => {
  if (section.dataset.ready) return;
  section.dataset.ready = 'true';
  const tabs = [...section.querySelectorAll('[data-category-tab]')];
  const activate = tab => {
   tabs.forEach(item => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
   section.querySelectorAll('[data-category-panel]').forEach(panel => { panel.hidden = panel.dataset.categoryPanel !== tab.dataset.categoryTab; });
  };
  tabs.forEach((tab, index) => {
   tab.addEventListener('click', () => activate(tab));
   tab.addEventListener('keydown', event => {
    let next;
    if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
    if (event.key === 'ArrowLeft') next = tabs[(index + tabs.length - 1) % tabs.length];
    if (event.key === 'Home') next = tabs[0];
    if (event.key === 'End') next = tabs[tabs.length - 1];
    if (next) { event.preventDefault(); activate(next); next.focus(); }
   });
  });
 });
 init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();

/* Mobile sticky add-to-cart: shows once the main Add to cart button scrolls out of view. */
(() => {
  const init = () => {
    const bar = document.querySelector('[data-minbie-sticky]');
    const main = document.querySelector('.product-form__submit');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    const footer = document.querySelector('.mb-footer');
    let mainVisible = true, footerVisible = false;
    const update = () => bar.classList.toggle('is-visible', !mainVisible && !footerVisible && main.getBoundingClientRect().top < 0);
    new IntersectionObserver(([e]) => { mainVisible = e.isIntersecting; update(); }).observe(main);
    if (footer) new IntersectionObserver(([e]) => { footerVisible = e.isIntersecting; update(); }).observe(footer);
    const price = bar.querySelector('[data-minbie-sticky-price]');
    document.addEventListener('change', (event) => {
      if (!event.target.closest('variant-selects, variant-radios')) return;
      setTimeout(() => {
        const current = document.querySelector('.product__info-container .price-item--last, .product__info-container .price__regular .price-item');
        if (current && price) price.textContent = current.textContent.trim();
        const btn = bar.querySelector('button');
        if (btn && main) { btn.disabled = main.disabled; btn.textContent = main.disabled ? 'Sold out' : 'Add to cart'; }
      }, 400);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
